"use client"
import {connect} from "react-redux";
import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Button } from "../../../components/ui/button";
import FlowTable from "./FlowTable";
import FilterControls from "./FilterControls";
import ReportScheduler from "./ReportScheduler";
import ExportButton from "./ExportButton";
import FlowModal from "./FlowModal";
import FlowModalETB from "./FlowModalETB";
import FlowModalFMM from './FlowModalFMM';
import "../../../components/ui/badge";
import { Input } from "../../../components/ui/input";
import {
  getWorkflowResults,
  getWorkflowResultsp2p,
  subscribeToFlowStatusUpdates,
  unsubscribeFromFlowStatusUpdates,
} from "../../../../ApiCalls/mantisFlowsManangment";
import Columns from "./Colums";
import FlowChat from "./FlowChat";
import FlowEditWorkflow from "./FlowEditWorkflow";
import FlowStats from "./FlowStats";
import FlowCreateStats from "./FlowCreateStats";
import "../../../../utils/payloadStats";
import "../../../../ApiCalls/FlowCreator/morpheus";
import { selectAuthState } from "../../../../store/selectors/authSelectors";

function FlowDetail({ flow, onBack, token, mantisBusiness, user }) {
  const [selectedData, setSelectedData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [activeFilters, setActiveFilters] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [flowResults, setFlowResults] = useState([]);
  const [morpheusFlow, setMorpheusFlow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [allColumns, setAllColumns] = useState([]);
  const [filterCategories, setFilterCategories] = useState([]);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isStatsMode, setIsStatsMode] = useState(false);
  const [isStatsOpen, setIsStatsOpen] = useState(false);
  const [statsPayload] = useState({
    currentStats: [],
    columnsExample: {},
  });
  const [statusUpdates, setStatusUpdates] = useState({});
  const [, setSseConnection] = useState(null);
  const [processingItems, setProcessingItems] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const paramItemId = searchParams.get("itemId");
  console.log(flowResults, "flowResults");
  console.log(selectedData, "selectedData");
  // Función para formatear nombres de columnas a un formato más amigable
  const formatColumnName = (columnName) => {
    // Convertir snake_case a palabras separadas
    const words = columnName.split("_");

    // Capitalizar cada palabra y unirlas con espacios
    return words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  // Función para determinar qué columnas mostrar y en qué orden
  const determineVisibleColumns = (data) => {
    if (!data || data.length === 0) return [];

    // Obtener todas las claves del primer objeto
    const allKeys = Object.keys(data[0]);

    // Excluir campos internos o de metadatos que no queremos mostrar
    const excludedColumns = ["id", "hasErrors", "isVerified", "status", "date"];

    // Filtrar las columnas que queremos mostrar
    return allKeys.filter((key) => !excludedColumns.includes(key));
  };

  //Format value
  const formatCellValue = (value) => {
    //If value contains only numbers, add commas
    if (/^\d+$/.test(value)) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
      return value;
    }
  };

  const fetchWorkflowResults = async (editingFromChat = false) => {
    try {
      setLoading(!editingFromChat);
      const clientId = mantisBusiness._id;
      let response;
      if ( clientId=== "67f3f66b52bb5c93527c1542" || clientId === "682b910ca728c4cd1996e3d2" || clientId === "6824470343029ff9bb1b72d4") {
        response = await getWorkflowResultsp2p(clientId);
      } else {
        response = await getWorkflowResults(clientId, flow.id, clientId);
      }

      if (response.success) {
        // Adaptamos los datos para que coincidan con el formato esperado
        const formattedResults = response.data.map((result) => {
          // Crear objeto base con los campos originales
          const formattedResult = { ...result };

          // Procesar custom_fields si existe
          if (result.custom_fields) {
            try {
              // Si custom_fields es un string, intentar parsearlo como JSON
              const customFields = typeof result.custom_fields === 'string' 
                ? JSON.parse(result.custom_fields) 
                : result.custom_fields;

              // Agregar cada campo de custom_fields como una propiedad individual
              Object.entries(customFields).forEach(([key, value]) => {
                formattedResult[key] = value;
              });
            } catch (error) {
              console.error('Error parsing custom_fields:', error);
            }
          }

          // Formatear campos específicos
          if (result.extraction_date) {
            formattedResult.extraction_date = new Date(
              result.extraction_date
            ).toLocaleString();
          }

          if (result.total_amount) {
            formattedResult.total_amount = `$${parseFloat(
              result.total_amount
            ).toLocaleString("es-CO")}`;
          }

          // Agregar campos adicionales para los filtros
          formattedResult.hasErrors = result.validation_status === "Rechazado";
          formattedResult.isVerified = result.validation_status === "Validado";
          formattedResult.status = mapValidationStatus(
            result.validation_status
          );
          formattedResult.date = result.extraction_date;

          return formattedResult;
        });

        setFlowResults(formattedResults);

        // Determinar dinámicamente las columnas visibles
        const columns = determineVisibleColumns(formattedResults);
        setVisibleColumns(columns);

        // Determinar todas las columnas disponibles (excluyendo las de metadatos)
        if (formattedResults.length > 0) {
          const allAvailableColumns = Object.keys(formattedResults[0]).filter(
            (col) =>
              col !== "hasErrors" &&
              col !== "isVerified" &&
              col !== "status" &&
              col !== "date" &&
              col !== "created_by_id" &&
              col !== "workflow_id" &&
              col !== "created_by" &&
              col !== "ai_summary" &&
              col !== "language" &&
              col !== "origin_channel" &&
              col !== "validations" &&
              col !== "custom_fields" // Excluimos el campo original custom_fields
          );
          setAllColumns(allAvailableColumns);
          setVisibleColumns(allAvailableColumns); // Inicialmente mostramos todas
        }
      } else {
        setError("No se pudieron cargar los resultados");
      }
    } catch (err) {
      console.error("Error al cargar los resultados:", err);
      setError("Error al cargar los resultados");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (flow && flow.id) {
      fetchWorkflowResults();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flow]);

  // Función para mapear los estados de validación a los estados de la UI
  const mapValidationStatus = (status) => {
    switch (status) {
      case "Validado":
        return "complete";
      case "Pendiente":
        return "pending";
      case "Rechazado":
        return "error";
      default:
        return "pending";
    }
  };

  const handleRowClick = (data) => {
    setSelectedData(data);
    setShowModal(true);
    // Agregar el parámetro itemId a la URL
    const params = new URLSearchParams(location.search);
    params.set("itemId", data.id);
    navigate(`${location.pathname}?${params.toString()}`);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    //Remmove itemId param from URL
    const params = new URLSearchParams(location.search);
    params.delete("itemId");
    navigate(`${location.pathname}?${params.toString()}`);
    setSelectedData(null);
    setSearchTerm("");
  };

  // Actualizar para recibir las categorías de filtros
  const handleFilterCategoriesUpdate = (categories) => {
    console.log("FlowDetail: Recibiendo categorías de filtros:", categories);
    setFilterCategories(categories);
  };

  const handleFilterToggle = (filter) => {
    console.log("FlowDetail: Toggle de filtro:", filter);
    if (activeFilters.includes(filter)) {
      setActiveFilters(activeFilters.filter((f) => f !== filter));
    } else {
      setActiveFilters([...activeFilters, filter]);
    }
  };

  const handleColumnToggle = (column) => {
    if (visibleColumns.includes(column)) {
      // Si la columna ya está visible, la ocultamos
      setVisibleColumns(visibleColumns.filter((col) => col !== column));
    } else {
      // Si la columna está oculta, la mostramos
      setVisibleColumns([...visibleColumns, column]);
    }
  };

  // Función mejorada para aplicar filtros dinámicos en FlowDetail.jsx
  
  // Aplicar búsqueda de texto
  
  // Filtrar los datos según los filtros activos y el término de búsqueda
  const filteredData = flowResults.filter((item) => {
    // Aplicar filtros
    if (activeFilters.length > 0) {
      const matchesAllFilters = activeFilters.every((filter) => {
        const { field, value } = filter;
        return item[field] === value;
      });
      if (!matchesAllFilters) return false;
    }

    // Aplicar búsqueda
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      const matchesSearch = Object.values(item).some(
        (val) => val && val.toString().toLowerCase().includes(searchLower)
      );
      if (!matchesSearch) return false;
    }

    return true;
  });

  // Crear un objeto que mapee los nombres de columnas originales a nombres formateados
  const columnLabels = {};
  allColumns.forEach((column) => {
    columnLabels[column] = formatColumnName(column);
  });

  
  // Función para manejar el cambio de modo de edición
  const handleEditModeChange = (isEditing) => {
    setIsEditMode(isEditing);
  };

  // Añadir console.log para verificar los datos
  useEffect(() => {
    console.log("FlowDetail - Datos disponibles:", {
      flowResults,
      allColumns,
      visibleColumns,
    });
    if (flowResults.length > 0 && paramItemId !== null) {
      const selectedItem = flowResults.find(
        (item) => item.id + "" === paramItemId
      );
      if (selectedItem) {
        setSelectedData(selectedItem);
        setShowModal(true);
      }
    }
  }, [flowResults, allColumns, visibleColumns, paramItemId]);

  const handleStatsMode = () => {
    setIsStatsMode(!isStatsMode);
    setIsChatOpen(true);
  };

  // Función para cargar los datos de estadísticas

  // Cargar los datos cuando se monta el componente
  // Función para abrir el chat de estadísticas
  const handleOpenStatsChat = () => {
    // Cerrar el chat normal si está abierto
    if (isChatOpen) {
      setIsChatOpen(false);
    }

    // Abrir el chat de estadísticas después de un pequeño retraso
    setTimeout(() => {
      setIsStatsOpen(true);
    }, 300);
  };

  // Subscribe to SSE updates when component mounts
  useEffect(() => {
    console.log("[FlowDetail] Setting up SSE connection for flow:", flow?.id);

    if (flow && flow.id) {
      // Handler for status updates
      const handleStatusUpdate = (update) => {
        console.log("[FlowDetail] Status update received:", update);

        // Update the status in state
        setStatusUpdates((prev) => {
          const newState = {
            ...prev,
            [update.userPhoneNumber]: update,
          };
          console.log("[FlowDetail] Updated statusUpdates state:", newState);
          return newState;
        });

        // If status is "processing", add to processing items
        if (update.status === "processing") {
          setProcessingItems((prev) => {
            if (!prev.includes(update.userPhoneNumber)) {
              return [...prev, update.userPhoneNumber];
            }
            return prev;
          });
        }

        // If status is "processed" or "error", remove from processing items
        if (update.status === "processed" || update.status === "error") {
          setProcessingItems((prev) =>
            prev.filter((phone) => phone !== update.userPhoneNumber)
          );
          fetchWorkflowResults(true); // Reload results when processing is done
        }
      };

      // Create SSE connection
      console.log("[FlowDetail] Creating SSE connection");
      const eventSource = subscribeToFlowStatusUpdates(
        flow.id,
        handleStatusUpdate
      );
      console.log("[FlowDetail] SSE connection created:", eventSource);
      setSseConnection(eventSource);

      // Clean up on unmount
      return () => {
        console.log("[FlowDetail] Cleaning up SSE connection");
        unsubscribeFromFlowStatusUpdates(eventSource);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flow?.id]);

  // Render status update indicators in the table
  const renderStatusIndicator = (phoneNumber) => {
    console.log(
      `[FlowDetail] Rendering status indicator for phone: ${phoneNumber}`,
      `Has update: ${Boolean(statusUpdates[phoneNumber])}`
    );

    const update = statusUpdates[phoneNumber];
    const isProcessing = processingItems.includes(phoneNumber);

    if (!update && !isProcessing) return null;

    if (isProcessing || (update && update.status === "processing")) {
      return (
        <div className="animate-pulse flex items-center space-x-2 px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
          <div className="h-2 w-2 bg-yellow-500 rounded-full"></div>
          <span>Procesando...</span>
        </div>
      );
    }

    if (!update) return null;

    console.log(`[FlowDetail] Status for ${phoneNumber}:`, update.status);

    switch (update.status) {
      case "received":
        return (
          <div className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
            Recibido
          </div>
        );
      case "processed":
        return (
          <div className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
            Procesado correctamente
          </div>
        );
      case "error":
        return (
          <div className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
            Error: {update.message || "Desconocido"}
          </div>
        );
      default:
        return null;
    }
  };

  if (loading) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
        className="space-y-6"
      >
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="flex items-center">
            <Button
              variant="ghost"
              size="icon"
              onClick={onBack}
              className="mr-2"
            >
              <ArrowLeft className="h-5 w-5" />
            </Button>
            <div>
              <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-100">
                {flow.name}
              </h2>
              <p className="text-slate-500 dark:text-slate-400">
                Cargando resultados...
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-slate-800 rounded shadow-sm border border-slate-200 dark:border-slate-700 p-8 text-center">
          <div className="animate-pulse flex flex-col items-center">
            <div className="h-8 w-8 bg-slate-200 dark:bg-slate-700 rounded-full mb-4"></div>
            <div className="h-4 w-48 bg-slate-200 dark:bg-slate-700 rounded mb-2.5"></div>
            <div className="h-3 w-32 bg-slate-200 dark:bg-slate-700 rounded"></div>
          </div>
        </div>
      </motion.div>
    );
  }

  if (error) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
        className="space-y-6"
      >
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div className="flex items-center">
            <Button
              variant="ghost"
              size="icon"
              onClick={onBack}
              className="mr-2"
            >
              <ArrowLeft className="h-5 w-5" />
            </Button>
            <div>
              <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-100">
                {flow.name}
              </h2>
              <p className="text-slate-500 dark:text-slate-400">
                Error al cargar resultados
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white dark:bg-slate-800 rounded shadow-sm border border-slate-200 dark:border-slate-700 p-8 text-center">
          <p className="text-red-500 font-medium">{error}</p>
        </div>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
      className="space-y-6 relative"
    >
      {/* Breadcrumbs */}
      <nav className="text-sm text-slate-500 dark:text-slate-400 flex items-center gap-2 mb-2" aria-label="Breadcrumb">
        <span className="hover:underline cursor-pointer" onClick={onBack}>Flow Management</span>
        <span className="mx-1">&gt;</span>
        <span className="font-semibold text-slate-700 dark:text-slate-200">{flow.name}</span>
      </nav>
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div className="flex items-center">
          <Button variant="ghost" size="icon" onClick={onBack} className="mr-2">
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <div>
            <h2 className="text-2xl font-bold text-slate-800 dark:text-slate-100">
              {flow.name}
            </h2>
            <p className="text-slate-500 dark:text-slate-400">
              {filteredData.length} de {flowResults.length} documentos
            </p>
          </div>
        </div>
      </div>

      {/* Componente de estadísticas separado del título */}
      <FlowStats
        flowData={{
          id: flow.id,
          name: flow.name,
          data: filteredData,
          nodes: flow.nodes || [],
          edges: flow.edges || [],
        }}
      />

      {/* Contenedor principal sin desplazamiento por el editor */}
      <motion.div
        animate={{
          marginRight: isChatOpen ? "400px" : "0px",
        }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
      >
        <div className="bg-white dark:bg-slate-800 rounded shadow-sm border border-slate-200/80 dark:border-slate-700/80 overflow-hidden">
          <div className="p-4 border-b border-slate-200/70 dark:border-slate-700/70">
            <div className="flex flex-wrap gap-4 items-center justify-between mb-4">
              <div className="flex items-center gap-2 flex-wrap">
                <FilterControls
                  data={flowResults}
                  activeFilters={activeFilters}
                  onFilterToggle={handleFilterToggle}
                  flowId={flow.id}
                  clientId={mantisBusiness._id}
                  onCategoriesUpdate={handleFilterCategoriesUpdate}
                />

                <Columns
                  allColumns={allColumns}
                  visibleColumns={visibleColumns}
                  onColumnToggle={handleColumnToggle}
                  columnLabels={columnLabels}
                />

                <ReportScheduler flowId={flow.id} flowName={flow.name} />

                <ExportButton
                  data={filteredData}
                  filename={`${flow.name
                    .toLowerCase()
                    .replace(/\s+/g, "-")}-export`}
                />
              </div>

              <div className="relative w-64">
                {/* <Search className="absolute left-2 top-2.5 h-4 w-4 text-slate-400 z-10" /> */}
                <Input
                  placeholder="Buscar registros..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-9 rounded-full border-slate-200/90 dark:border-slate-700/90 focus:border-slate-300 dark:focus:border-slate-600"
                />
              </div>
            </div>
          </div>

          <div className="overflow-hidden">
            <FlowTable
              data={filteredData}
              visibleColumns={visibleColumns}
              onRowClick={handleRowClick}
              columnLabels={columnLabels}
              statusIndicator={renderStatusIndicator}
              flowId={flow.id}
              processingItems={processingItems}
            />
          </div>
        </div>
      </motion.div>

      {/* Componente de chat */}
      <FlowChat
        flowData={{
          id: flow.id,
          name: flow.name,
          idClient: mantisBusiness._id,
          idFlow: flow.id,
          currentStats: statsPayload.currentStats,
          columnsExample: statsPayload.columnsExample,
          data: filteredData,
        }}
        isOpen={isChatOpen}
        onToggle={() => setIsChatOpen(!isChatOpen)}
        onEditModeChange={handleEditModeChange}
        handleStatsMode={handleStatsMode}
        onOpenStatsChat={handleOpenStatsChat}
        reloadFlow={() => {
          fetchWorkflowResults(true);
        }}
        updateMorpheusWorkflow={(flow) => {
          setMorpheusFlow(flow);
        }}
      />

      {/* Editor de flujo como modal con fondo semitransparente */}
      <AnimatePresence>
        {isEditMode && (
          <>
            {/* Overlay semitransparente */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="fixed inset-0 bg-slate-900/50 z-40"
              onClick={() => setIsEditMode(false)}
            />

            {/* Editor de flujo - ajustado para alinearse con el chat */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 20 }}
              transition={{ duration: 0.3 }}
              className="fixed z-50 rounded overflow-hidden shadow-xl"
              style={{
                width: isChatOpen
                  ? "calc(100vw - 450px)"
                  : "calc(100vw - 100px)",
                height: "calc(100vh - 180px)",
                top: "90px",
                left: isChatOpen ? "25px" : "50px",
                margin: 0, // Eliminamos cualquier margen
              }}
            >
              <FlowEditWorkflow
                flowData={{
                  name: flow.name,
                  nodes:
                    morpheusFlow?.visualization?.visualization?.nodes || [],
                  edges:
                    morpheusFlow?.visualization?.visualization?.edges || [],
                  columns: allColumns || [],
                  visibleColumns: visibleColumns || [],
                }}
                isOpen={isEditMode}
                onClose={() => setIsEditMode(false)}
              />
            </motion.div>
          </>
        )}
      </AnimatePresence>
      {/* Modal de detalles - Con altura máxima y scroll interno */}
      {showModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 overflow-hidden">
          <div
            className="fixed inset-0 bg-black/50 backdrop-blur-sm"
            onClick={handleCloseModal}
          />
          <div className="relative z-[101] w-full max-w-[90vw] mx-auto max-h-[90vh] flex flex-col bg-white dark:bg-slate-900 c shadow-xl">
            {/* Contenedor con scroll interno */}
            <div className="flex-1 overflow-y-auto">
              {mantisBusiness._id === "67f495ec52bb5c93527c2ef7" ? (
                <FlowModalETB
                  data={selectedData}
                  onClose={handleCloseModal}
                  clientId={mantisBusiness._id}
                  workflowId={flow.id}
                />
              ) : mantisBusiness._id === "67f3f66b52bb5c93527c1542" || mantisBusiness._id === "682b910ca728c4cd1996e3d2" || mantisBusiness._id === "6824470343029ff9bb1b72d4" ? (
                <FlowModalFMM
                  data={{
                    ...selectedData,
                    client_id: mantisBusiness._id,
                    workflow_id: flow.id,
                    order_id: selectedData?.id || selectedData?._id,
                  }}
                  onClose={handleCloseModal}
                  columnLabels={columnLabels}
                  formatCellValue={formatCellValue}
                  isOpen={showModal}
                />
              ) : (
                <FlowModal
                  data={selectedData}
                  onClose={handleCloseModal}
                  clientId={mantisBusiness._id}
                  workflowId={flow.id}
                />
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal de estadísticas - Sin borde superior */}
      {isStatsOpen && (
        <AnimatePresence>
          <div className="fixed inset-0 z-50 flex items-center justify-center m-0 p-0 border-t-0">
            <div
              className="absolute inset-0 bg-black/50 backdrop-blur-sm"
              onClick={() => setIsStatsOpen(false)}
            />
            <div className="relative z-10 border-t-0">
              <FlowCreateStats
                flowData={{
                  id: flow.id,
                  name: flow.name,
                  idClient: mantisBusiness._id,
                  idFlow: flow.id,
                  currentStats: statsPayload.currentStats,
                  columnsExample: statsPayload.columnsExample,
                }}
                isOpen={isStatsOpen}
                onToggle={() => {
                  setIsStatsOpen(false);
                }}
              />
            </div>
          </div>
        </AnimatePresence>
      )}
    </motion.div>
  );
}

export default connect(selectAuthState)(FlowDetail);